<template>
    <div class="dv5-main" :class="{ 'grid-WL': !view.father_is_builderall }">
        <div class="dv5-content"> <!-- se necessario separar componente -->
            <dv5-shared-collapse :view="collapseList[0]" v-if="false" :num="0" :externalCollapse="AllColapses[0].colapsed" :isColapsed="isColapsed">
                <span :slot="'title'" slot-scope="props" :class="props.titleClass">{{props.title}}</span>
                <span :slot="'subtitle'" slot-scope="props" :class="props.subtitleClass">{{props.subtitle}}</span>
                <dv5-shared-carousel
                    :slot="'content'"
                    slot-scope="props"
                    :view="props.content"
                >
                    <div
                        class="slide-wrapper"
                        :slot="'slide'"
                        slot-scope="props"
                        :class="props.slideClass"
                    >
                        <dv5-my-stuff-tool-card  :view="props.slide" :getToolByIntelligenceId="getToolByIntelligenceId" :available_tools="view.available_tools" :handler_routes="view.handler_routes" :t="view.translation" />
                    </div>
                </dv5-shared-carousel>
            </dv5-shared-collapse>

            <dv5-shared-collapse :view="collapseList[1]" v-show="!view.father_is_cheetah_for_wp_pro && !view.father_is_worckie_pro && !view.father_is_server_pronto" :num="1" :externalCollapse="AllColapses[1].colapsed" :isColapsed="isColapsed">
                <span :slot="'title'" slot-scope="props" :class="props.titleClass">{{props.title}}</span>
                <span :slot="'subtitle'" slot-scope="props" :class="props.subtitleClass">{{props.subtitle}}</span>
                <dv5-start-a-project :slot="'content'" slot-scope="props" :view="view"/>
            </dv5-shared-collapse>

            <dv5-shared-collapse :view="collapseList[2]" :num="2" :externalCollapse="AllColapses[2].colapsed || view.father_is_cheetah_for_wp_pro || view.father_is_worckie_pro || view.father_is_server_pronto" :isColapsed="isColapsed">
                <span :slot="'title'" slot-scope="props" :class="props.titleClass">{{props.title}}</span>
                <span :slot="'subtitle'" slot-scope="props" :class="props.subtitleClass">{{props.subtitle}}</span>
                <dv5-tool :slot="'content'" slot-scope="props" :view="view" />
            </dv5-shared-collapse>
        </div>
        <div class="dv5-footer">
            <dv5-bottom-banner
                v-if="view.father_is_builderall && view.banner_info_footer !== undefined && view.banner_info_footer !== null && view.banner_info_footer != '[]' && view.theme_type != 'DEFAULT'"
                class="bottom-banner"
                :view="view.banner_info_footer"
                :app="view.app"
            />
        </div>
    </div>
</template>


<script>
    import axios from "axios";

    export default {
        name: "dv5-main",
        props: ["view"],
        data() {
            return {
                collapseList: [
                    {
                        title: this.view.translation.my_stuff.title,
                        subtitle: this.view.translation.my_stuff.subtitle,
                        externalCollapse: false,
                        content: [] // can be object
                    },
                    {
                        title: this.view.translation.start_a_project.title,
                        subtitle: this.view.translation.start_a_project.subtitle,
                        externalCollapse: false,
                        content: []// can be object
                    },
                    {
                        title: this.view.translation.tools.title,
                        subtitle: this.view.translation.tools.subtitle,
                        externalCollapse: false,
                        content: [] // can be object
                    }
                ],
                AllColapses: [
                    { colapsed: true },
                    { colapsed: false },
                    { colapsed: true }
                ],
                windowWidth: window.innerWidth,
                collapsed: false,
            };
        },

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        created() {
            this.getMyStuffTools()
            console.log('index', this.view)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        methods: {
            getMyStuffTools: async function (){
                // try{
                //     let email = this.view.email;
                //     let url = `https://intelligence.builderall.com/quick-links/${email}`;
                //     let result = await axios.get(url);
                //     let hasSuperCheckoutSession = false;
                //     result = result.data

                //     var uniqueLinks   = [],
                //         linksToRemove = [];

                //     // Check if has Super Checkout Session
                //     let hasSuperCheckout = result.some(tool => tool['name'] == 'super-checkout');
                //     if(hasSuperCheckout) {
                //         try {
                //             let axiosInstance = axios.create();
                //             delete axiosInstance.defaults.headers.common['X-Requested-With'];
                //             await axiosInstance
                //                     .get('https://s-checkout.builderall.com',{withCredentials: true})
                //                     .then(response => {
                //                         if(response.status == 200) {
                //                             hasSuperCheckoutSession = true;
                //                         }
                //                     })
                //                     .catch(e => {console.log('err check sc sess', e);})
                //         }
                //         catch(e) { console.log('sc check sess', e); }
                //     }

                //     for(let i=0, len=result.length; i < len; i++){

                //         // adjust my stuff to hide cards not allowed for VA
                //         if(this.view.isva == true && !this.view.available_tools.includes(result[i].name)) { linksToRemove.push(i); continue;}

                //         if(result[i].name == 'super-checkout') {
                //             // Remove Super Checkout card from My Stuff if nos has Super Checkout Session
                //             if(!hasSuperCheckoutSession) { linksToRemove.push(i); continue;}
                //         }

                //         if(result[i].hasOwnProperty('additional_info') && result[i].additional_info !== undefined && result[i].additional_info !== null) {
                //             try {
                //                 var parsed = JSON.parse(result[i].additional_info);
                //                 result[i].additional_info = parsed;
                //             }catch(e) {
                //                 var sanitaze = result[i].additional_info.split(',"script":{');
                //                 if(sanitaze.length > 1) {
                //                     sanitaze = sanitaze[0] + "}]}";
                //                     try{
                //                         parsed = JSON.parse(sanitaze);
                //                         result[i].additional_info = parsed;
                //                     } catch(e) {
                //                         console.log('error on decode my_stuff.additional_info', result[i].additional_info, e);
                //                         continue;
                //                     }
                //                 } else {
                //                     continue;
                //                 }
                //             }
                //         }

                //         //if(result[i].url !== undefined && result[i].url !== null) {
                //         result[i].buttonText = this.view.translation.shared.label_btn_dv5_my_stuff_card
                //         //}

                //         // verify if additional_info has defied
                //         if(result[i].hasOwnProperty('additional_info') && result[i].additional_info !== undefined && result[i].additional_info !== null) {

                //             // mark duplicated card
                //             if(result[i].additional_info.hasOwnProperty('id') && String(result[i].additional_info.id).length) {
                //                 var _reference = result[i].name+'-'+result[i].additional_info.id,
                //                     _index     = uniqueLinks.indexOf(_reference);

                //                 if (_index == -1) {
                //                     uniqueLinks.push(_reference);
                //                 } else {
                //                     linksToRemove.push(i);
                //                 }
                //             }

                //             // mark card to deleted
                //             if(
                //                 result[i].additional_info.hasOwnProperty('deleted_at')
                //                 && result[i].additional_info.deleted_at !== undefined
                //                 && result[i].additional_info.deleted_at !== null
                //                 && String(result[i].additional_info.deleted_at).length
                //             ) {
                //                 linksToRemove.push(i);
                //             }
                //         }

                //     }

                //     linksToRemove.reverse();  // remove end to start to prevent remove incorrect array index
                //     // remove duplicated resources
                //     for(let i=0, leng=linksToRemove.length; i < leng; i++){
                //         result.splice(linksToRemove[i], 1);
                //     }

                //     // Remove data empty
                //     result = result.filter(x => !this.IsEmpty(x.url))

                //     this.$set(this.collapseList[0], 'content', result)
                //     if(result.length > 0) {
                //         this.collapseList[0].externalCollapse = true;
                //     } else {
                //         this.collapseList[1].externalCollapse = true;
                //     }
                // }catch(e) {
                //     console.log("error: ", e.getMessage())
                //     this.collapseList[1].externalCollapse = true;
                // }finally{
                // }
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            getToolByIntelligenceId(id) {

                var tool = this.view.tools.filter(function(_tool){
                    if(_tool.intelligence_references && Object.keys(_tool.intelligence_references).length){
                        return _tool.intelligence_references.id == id;
                    }
                });

                tool = tool.length ? tool[0] : false; // if find then return tool infos, else return false
                return tool;
            },
            isColapsed(value, index) {
                // for (let i = 0; i < this.AllColapses.length; i++) {
                //     this.AllColapses[i].colapsed = false
                // }
                this.AllColapses[index].colapsed = value
                if (this.AllColapses[index].colapsed == true) {
                    $('.container__grid').css('padding','0 5.80829165% 15rem 5.80829165%')
                } else {
                    $('.container__grid').css('padding','0 5.80829165% 3rem 5.80829165%')
                }
            },
            IsEmpty(val) {
              return isEmpty(val)
            }
        },
        computed: {
            footerBannerMarginTop: function() {
                return {
                    marginTop: this.collapseList[0].content.length > 0 ? '40vh' : '48vh'
                };
            }
        },
        watch: {
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.footer__add__more .add__more__apps{
    display: none !important;
}
#content{
    padding: 0% !important;
}
</style>
<style scoped lang="scss">
    @import '../../../scss/extras/_variables';
    .dv5-main{
        font-family: $dv5-font1;
        font-size: 0.625rem!important; /* 10px */
        text-align: center;
        max-width: calc( 88.3834167vw - 350px ); // prevent slider overflow

        .dv5-header,
        .dv5-content,
        .dv5-footer{
            font: inherit;
            margin: 0 auto;
            text-align: left;
            max-width: 98%;
        }
        .dv5-support {
            padding: 1em 4em 0 4em;
        }
        .dv5-footer{
            transition: .8s;
            font: inherit;
            padding: 1em 6em 0 6em;
            border-radius: 4px!important;

            width: 100%;
            max-width: calc( 88.3834167vw - 350px ); // prevent slider overflow
            bottom: 3rem;
        }
    }
    .slide-wrapper{
        padding: 5px 5px;
        font-size: 10px;
        font-family: $dv5-font1;
        background-color: rgba(#B8BBBF, 0.05)!important;
        border-radius: 8px!important;
    }
    @media (max-width: 700px) {
        .dv5-main{
            max-width: 88vw;
            .dv5-support {
                padding: 1em 1em 0 1em;
            }
            .dv5-footer{
                transition: .8s;
                padding-left: 0;
                padding-right: 0;
                margin-top: 2vh!important;
                margin-bottom: 1vh !important;
                margin-left: auto;

                max-width: 98%;
                position: inherit;
            }
        }
    }
    @media (max-width: 400px) {
        .dv5-main{
            max-width: 96vw;
            .dv5-support {
                padding: 1em 2em 0 2em;
            }
        }
    }
    .margin-none {
        transition: .8s;
        margin-top: 0 !important;
    }
    .grid-WL {
        max-width: 88.3834167vw;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/index.vue